import { useEffect, useRef, useState } from 'react';
import { Arrow } from './ui';

export function Nav() {
  const [open, setOpen] = useState(false);
  const toggle = useRef(null);
  const header = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    function closeOnEscape(event) {
      if (event.key === 'Escape') {
        setOpen(false);
        toggle.current?.focus();
      }
    }
    function closeOutside(event) {
      if (!header.current?.contains(event.target)) setOpen(false);
    }
    document.addEventListener('keydown', closeOnEscape);
    document.addEventListener('pointerdown', closeOutside);
    return () => {
      document.removeEventListener('keydown', closeOnEscape);
      document.removeEventListener('pointerdown', closeOutside);
    };
  }, [open]);

  return (
    <header className="site-header" ref={header}>
      <div className="nav-inner container">
        <a className="wordmark" href="#home" aria-label="Maycie Morris, home" onClick={() => setOpen(false)}>maycie<span>morris</span><span className="wordmark-dot">.</span></a>
        <button className="menu-toggle" ref={toggle} aria-controls="primary-nav" aria-expanded={open} onClick={() => setOpen(!open)}>
          {open ? 'Close' : 'Menu'} <span aria-hidden="true">{open ? '−' : '+'}</span>
        </button>
        <nav id="primary-nav" className={open ? 'primary-nav is-open' : 'primary-nav'} aria-label="Main navigation">
          <a href="#work" onClick={() => setOpen(false)}>Selected work</a>
          <a href="#about" onClick={() => setOpen(false)}>About</a>
          <a href="#expertise" onClick={() => setOpen(false)}>Expertise</a>
          <a className="nav-contact" href="#contact" onClick={() => setOpen(false)}>Get in Touch <Arrow /></a>
        </nav>
      </div>
    </header>
  );
}
